export const devUserGroups = [
	// Beware: these needs to be sorted by priority as they're used in userGroupsSortedByHierarchy
	'rome-dev',
	'ai-dev',
	'system-admin',
	'support',
] as const;

export const bedcUserGroups = [
	// Beware: these needs to be sorted by priority as they're used in userGroupsSortedByHierarchy
	'manager',
	'accounting',
	'team-leader',
	'estimator',
	'estimator+external',
	'client',
	'client-manager',
	'sales',
	'customer',
] as const;

export const saasUserGroups = [
	// Beware: these needs to be sorted by priority as they're used in userGroupsSortedByHierarchy
	'saas-manager',
	'saas-accounting',
	'saas-estimator',
	'saas-sales',
	'saas-production',
	'saas-delivery',
] as const;

/**
 * User groups that count as estimators — the population surfaced by the
 * estimator search and the only users whose performance charts may be viewed.
 */
export const estimatorUserGroups = ['estimator+external', 'estimator'] as const;

export const additiveUserGroups = ['recipe-admin', 'hitl-specialist'] as const;

export const romeUserGroups = [
	// Beware: these needs to be sorted by priority as they're used in userGroupsSortedByHierarchy
	...devUserGroups,
	...bedcUserGroups,
	...saasUserGroups,
	...additiveUserGroups,
] as const;

export const integrationUserGroups = [
	'integration',
	'alpine-support',
	'alpine-web-portal-integration',
	'v2e-integration',
] as const;

export const userGroups = [...romeUserGroups, ...integrationUserGroups] as const;

export const userGroupsSortedByHierarchy = [
	...devUserGroups,
	//
	'alpine-support',
	//
	'manager',
	'team-leader',
	...estimatorUserGroups,
	'sales',
	'accounting',
	'client-manager',
	//
	'saas-manager',
	'saas-accounting',
	'saas-estimator',
	'saas-sales',
	'saas-production',
	'saas-delivery',
	//
	'client',
	'customer',
] as const;
